module.exports = __webpack_public_path__ + "img/Weapon_101.b351f04b.png";